module.exports = __webpack_public_path__ + "assets/media/notification.3664e6be.png";


//////////////////
// WEBPACK FOOTER
// ./src/layouts/VideoInstallStep/assets/notification.png
// module id = 3240
// module chunks = 0